import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "src/store/actions";
import {
  initialState,
  handleEditDamagedQuantity,
  handleAddAttachment,
  handleRemoveAttachment,
  handleReset,
  handleUpdateNavigationBlocking,
  handleUpdateNotes,
  handleUpdateReasonForClaim,
  handleUpdateApproverNotes,
  handleAddApproverAttachment,
  handleRemoveApproverAttachment,
  handleRejectPostEditFreightClaim,
  handlePendingGetProductsForFC,
  handleCombineFcAndTransferItems,
  handleSelectAllPalletItems,
  handleFulFillGetProductsForFC,
  handleRejectGetProductsForFC,
  handleFulFillPostEditFreightClaim,
  handlePendingPostEditFreightClaim,
  handleRejectUploadFreightClaimAttachments,
  handleFulFillUploadFreightClaimAttachments,
  handlePendingUploadFreightClaimAttachments,
  handleFulfilledForFetchTransferDetails,
  handlePendingForFetchTransferDetails,
  handleRejectedForFetchTransferDetails,
  handleGetStoreCreditDetailsForFcFulfilled,
  handleGetStoreCreditDetailsForFcPending,
  handleGetStoreCreditDetailsForFcRejected
} from "./EditFcReducers";
import {
  getProductsForFC,
  postEditFreightClaim,
  uploadFreightClaimAttachments,
  fetchTransferDetails,
  getStoreCreditDetailsForFC
} from "./EditFcAsyncThunks";

const editFreightClaimSlice = createSlice({
  name: "editFreightClaim",
  initialState,
  reducers: {
    handleEditDamagedQuantity,
    handleAddAttachment,
    handleRemoveAttachment,
    handleReset,
    handleUpdateNavigationBlocking,
    handleUpdateNotes,
    handleUpdateReasonForClaim,
    handleUpdateApproverNotes,
    handleAddApproverAttachment,
    handleRemoveApproverAttachment,
    handleCombineFcAndTransferItems,
    handleSelectAllPalletItems
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, (_state, _action) => {
        return initialState;
      })
      .addCase(
        uploadFreightClaimAttachments.pending,
        handlePendingUploadFreightClaimAttachments
      )
      .addCase(
        uploadFreightClaimAttachments.fulfilled,
        handleFulFillUploadFreightClaimAttachments
      )
      .addCase(
        uploadFreightClaimAttachments.rejected,
        handleRejectUploadFreightClaimAttachments
      )
      .addCase(postEditFreightClaim.pending, handlePendingPostEditFreightClaim)
      .addCase(
        postEditFreightClaim.fulfilled,
        handleFulFillPostEditFreightClaim
      )
      .addCase(postEditFreightClaim.rejected, handleRejectPostEditFreightClaim)
      .addCase(getProductsForFC.pending, handlePendingGetProductsForFC)
      .addCase(getProductsForFC.fulfilled, handleFulFillGetProductsForFC)
      .addCase(getProductsForFC.rejected, handleRejectGetProductsForFC)
      .addCase(
        fetchTransferDetails.pending,
        handlePendingForFetchTransferDetails
      )
      .addCase(
        fetchTransferDetails.fulfilled,
        handleFulfilledForFetchTransferDetails
      )
      .addCase(
        fetchTransferDetails.rejected,
        handleRejectedForFetchTransferDetails
      )
      .addCase(
        getStoreCreditDetailsForFC.pending,
        handleGetStoreCreditDetailsForFcPending
      )
      .addCase(
        getStoreCreditDetailsForFC.fulfilled,
        handleGetStoreCreditDetailsForFcFulfilled
      )
      .addCase(
        getStoreCreditDetailsForFC.rejected,
        handleGetStoreCreditDetailsForFcRejected
      );
  }
});

export const {
  handleEditDamagedQuantity: editDamagedQuantity,
  handleAddAttachment: addAttachment,
  handleRemoveAttachment: removeAttachment,
  handleReset: reset,
  handleUpdateNavigationBlocking: updateNavigationBlocking,
  handleUpdateNotes: updateNotes,
  handleUpdateReasonForClaim: updateReasonForClaim,
  handleUpdateApproverNotes: updateApproverNotes,
  handleAddApproverAttachment: addApproverAttachment,
  handleRemoveApproverAttachment: removeApproverAttachment,
  handleCombineFcAndTransferItems: combineFcAndTransferItems,
  handleSelectAllPalletItems: selectAllPalletItems
} = editFreightClaimSlice.actions;

export default editFreightClaimSlice.reducer;
